export const orderFilters = () => ({
        orderId: null,
        serviceName: null,
        travelerName: null,
        city: null,
        createdDateFrom: null,
        createdDateTo: null,
        serviceStartDateFrom: null,
        serviceStartDateTo: null,
        serviceEndDateFrom: null,
        serviceEndDateTo: null,
        serviceTypes: [],
        filterServices: true,
        processStatuses: [],
        customerPaymentStatuses: [],
        customerInvoiceStatuses: [],
        customerPenalty: [],
        supplier: null,
        supplierPaymentStatuses: [],
        supplierInvoiceStatuses: [],
        supplierPenalty: [],
        paymentMethod: [],
        customerCompany: null,
        modifiedDateFrom: null,
        modifiedDateTo: null,
        lastTicketingDateFrom: null,
        lastTicketingDateTo: null,
        reservationStatuses: [],
        reservationName: null,
        reservationManager: null,
        serviceManager: null,
        ticketNumber: null,
        promoCode: null,
        loyaltyPointsMin: null,
        loyaltyPointsMax: null,
        clientType: null,
        crmPriority: null,
        agent: null,
        client: null,
        tripOrganizer: null,
        corporatePolicyViolated: null,
        waitAuthorize: false,
        noSupplierRef: false,
        supplierRef: null,
        channelManagerCode: null,
        chmPartnerBookingNumber: null,
        serviceSources: [],
        bookingMethod: [],
        customerPaymentDueDateFrom: null,
        customerPaymentDueDateTo: null,
        supplierPaymentDueDateFrom: null,
        supplierPaymentDueDateTo: null,
        active: true,
        externalRefNumber: null,
        agentRefNumber: null,
        departmentId: null,
        productId: null,
        serviceDepartmentId: null,
    }),
    ordersResponse = () => ({
        orders: [],
    })
